// extracted by mini-css-extract-plugin
export default {"watch":"Wacth_watch__12Lwz"};